module.exports = __webpack_public_path__ + "static/media/link-icon.5a9179f2.svg";